export default __webpack_public_path__ + "static/media/read-checkbox.b6f41f68.svg";